import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position" }
const _hoisted_2 = { class: "position__row" }
const _hoisted_3 = { class: "position__row" }
const _hoisted_4 = { class: "position__row" }

import { storeToRefs } from 'pinia';

import { useServicesStore } from '@/store/services';
import { TPosition } from '@/types/shadow/TPosition';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PositionList',
  setup(__props) {

const { shadowParams } = storeToRefs(useServicesStore());

const setPosition = (position: TPosition): void => {
  shadowParams.value.position = position;
};


return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AiClearButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setPosition('top'))),
          class: _normalizeClass(["position__button", {'position__button--active': _unref(shadowParams).position === 'top'}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/icons/shadow/position/top-position.svg')
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AiClearButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setPosition('left'))),
          class: _normalizeClass(["position__button", {'position__button--active': _unref(shadowParams).position === 'left'}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/icons/shadow/position/left-position.svg')
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(AiClearButton, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setPosition('center'))),
          class: _normalizeClass(["position__button", {'position__button--active': _unref(shadowParams).position === 'center'}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/icons/shadow/position/center-position.svg')
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(AiClearButton, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setPosition('right'))),
          class: _normalizeClass(["position__button", {'position__button--active': _unref(shadowParams).position === 'right'}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/icons/shadow/position/right-position.svg')
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AiClearButton, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setPosition('bottom'))),
          class: _normalizeClass(["position__button", {'position__button--active': _unref(shadowParams).position === 'bottom'}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/icons/shadow/position/bottom-position.svg')
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}
}

})